import { getRequest, patchRequest } from "../api/methodsCfg";

/** Get all bookings for a restaurant (with optional filters). */
export const getRestaurantBookings = async (restaurantId, params = {}) => {
  const response = await getRequest(`/booking/restaurant/${restaurantId}`, params);
  return response;
};

/** Get a single booking by ID. */
export const getBookingById = async (bookingId) => {
  const response = await getRequest(`/booking/${bookingId}`);
  return response;
};

/** Cancel a booking. */
export const cancelBooking = async (bookingId) => {
  const response = await patchRequest(`/booking/${bookingId}/cancel`);
  return response;
};
